export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const LOG_OUT = "LOG_OUT";
export const AUTH_REFRESHED = "AUTH_REFRESHED";
export const VALIDATION_START = 'VALIDATION_START'
export const VALIDATION_SUCCESS = 'VALIDATION_SUCCESS'
export const VALIDATION_FAIL = 'VALIDATION_FAIL'
export const FORGOT_PASSWORD_STEP_ONE_START = 'FORGOT_PASSWORD_STEP_ONE_START'
export const FORGOT_PASSWORD_STEP_ONE_SUCCESS = 'FORGOT_PASSWORD_STEP_ONE_SUCCESS'
export const FORGOT_PASSWORD_STEP_ONE_FAIL = 'FORGOT_PASSWORD_STEP_ONE_FAIL'
export const FORGOT_PASSWORD_STEP_TWO_START = 'FORGOT_PASSWORD_STEP_TWO_START'
export const FORGOT_PASSWORD_STEP_TWO_SUCCESS = 'FORGOT_PASSWORD_STEP_TWO_SUCCESS'
export const FORGOT_PASSWORD_STEP_TWO_FAIL = 'FORGOT_PASSWORD_STEP_TWO_FAIL'
export const SET_ERROR = 'SET_ERROR'